import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import Typography from '@material-ui/core/Typography';
import ButtonWithIcon from '../components/ButtonWithIcon';
import TypoFramed from '../components/TypoFramed';
import Card from '../components/Card';
import PopupFederationOffices from '../popups/PopupFederationOffices';
import PopupFederationSocial from '../popups/PopupFederationSocial';
import PopupFederationCoop from '../popups/PopupFederationCoop';
import PopupFederationProcivis from '../popups/PopupFederationProcivis';
import PopupFederationAssociations from '../popups/PopupFederationAssociations';
import PopupArticle from '../popups/PopupArticle';
import PopupTimeline from '../components/PopupTimeline';
import PopupInterview from '../components/PopupInterview';
import PopupAnnexeIncome from '../popups/PopupAnnexeIncome';
import PopupUE from '../popups/PopupUE';
import PopupTaxationEvolution from '../popups/PopupTaxationEvolution';
import PopupBIM from '../popups/PopupBIM';
import PopupOrganismEscort from '../popups/PopupOrganismEscort';
import PopupAlliance from '../popups/PopupAlliance';
import PopupProject from '../popups/PopupProject';
import PopupSchool from '../popups/PopupSchool';
import PopupEmmanuelleCosse from '../popups/PopupEmmanuelleCosse';
import PopupMarianneLouis from '../popups/PopupMarianneLouis';
import PopupSylvieRuin from '../popups/PopupSylvieRuin';
import PopupLowCarbon from '../popups/PopupLowCarbon';
import PopupEaseAccess from '../popups/PopupEaseAccess';
import PopupPropositions from '../popups/PopupPropositions';
import PopupSocialImpact from '../popups/PopupSocialImpact';
import PopupEvents from '../popups/PopupEvents';
import PopupRevival from '../popups/PopupRevival';
import PopupStrategy from '../popups/PopupStrategy';
import PopupQualiHlm from '../popups/PopupQualiHlm';
import PopupDiagnostic from '../popups/PopupDiagnostic';
import PopupTFPB from '../popups/PopupTFPB';
import PopupRoadmap from '../popups/PopupRoadmap';
import PopupIsabelleRueff from '../popups/PopupIsabelleRueff';
import PopupDialogue from '../popups/PopupDialogue';
import PopupSafety from '../popups/PopupSafety';
import PopupJeremyEstrader from '../popups/PopupJeremyEstrader';
import PopupStephaneDauphin from '../popups/PopupStephaneDauphin';
import PopupSecularism from '../popups/PopupSecularism';
import PopupMarieLaureVuittenez from '../popups/PopupMarieLaureVuittenez';
import Slider from '../components/Slider';

import { ReactComponent as Add } from '../res/add.svg';
import { ReactComponent as Download } from '../res/download.svg';
import { ReactComponent as Play } from '../res/play.svg';
import { ReactComponent as Podcast } from '../res/podcast.svg';

class SystemDesignDemo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { data, baseUrl } = this.props;
    return (
      <div>
        <Typography variant="h3" gutterBottom>
          Les Pop-ups
        </Typography>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupFederationSocial: true })}>
          Pop-up composée FederationSocial
        </ButtonWithIcon>
        <PopupFederationSocial
          data={data}
          baseUrl={baseUrl}
          open={this.state.popupFederationSocial}
          onClose={() => this.setState({ popupFederationSocial: false })}
        ></PopupFederationSocial>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupFederationCoop: true })}>
          Pop-up composée FederationCoop
        </ButtonWithIcon>
        <PopupFederationCoop
          data={data}
          baseUrl={baseUrl}
          open={this.state.popupFederationCoop}
          onClose={() => this.setState({ popupFederationCoop: false })}
        ></PopupFederationCoop>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupFederationProcivis: true })}>
          Pop-up composée FederationProcivis
        </ButtonWithIcon>
        <PopupFederationProcivis
          data={data}
          baseUrl={baseUrl}
          open={this.state.popupFederationProcivis}
          onClose={() => this.setState({ popupFederationProcivis: false })}
        ></PopupFederationProcivis>
        <ButtonWithIcon
          color="black"
          icon={<Add />}
          onClick={() => this.setState({ popupFederationAssociations: true })}
        >
          Pop-up composée FederationAssociations
        </ButtonWithIcon>
        <PopupFederationAssociations
          data={data}
          baseUrl={baseUrl}
          open={this.state.popupFederationAssociations}
          onClose={() => this.setState({ popupFederationAssociations: false })}
        ></PopupFederationAssociations>

        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupSecularism: true })}>
          Pop-up composée Secularism
        </ButtonWithIcon>
        <PopupSecularism
          data={data}
          baseUrl={baseUrl}
          open={this.state.popupSecularism}
          onClose={() => this.setState({ popupSecularism: false })}
        ></PopupSecularism>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupIntervention: true })}>
          Pop-up composée Intervention
        </ButtonWithIcon>
        <PopupTimeline
          color="green"
          timelinePopupData={data.popup.intervention}
          open={this.state.popupIntervention}
          onClose={() => this.setState({ popupIntervention: false })}
        ></PopupTimeline>
        <ButtonWithIcon color="black" icon={<Play />} onClick={() => this.setState({ popupMarieLaureVuittenez: true })}>
          Pop-up composée Marie-Laure Vuittenez
        </ButtonWithIcon>
        <PopupMarieLaureVuittenez
          data={data}
          baseUrl={baseUrl}
          open={this.state.popupMarieLaureVuittenez}
          onClose={() => this.setState({ popupMarieLaureVuittenez: false })}
        ></PopupMarieLaureVuittenez>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupStephaneDauphin: true })}>
          Pop-up composée Stéphane Dauphin
        </ButtonWithIcon>
        <PopupStephaneDauphin
          data={data}
          baseUrl={baseUrl}
          open={this.state.popupStephaneDauphin}
          onClose={() => this.setState({ popupStephaneDauphin: false })}
        ></PopupStephaneDauphin>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupAwarding: true })}>
          Pop-up composée Awarding
        </ButtonWithIcon>
        <PopupTimeline
          color="green"
          timelinePopupData={data.popup.awarding}
          open={this.state.popupAwarding}
          onClose={() => this.setState({ popupAwarding: false })}
        ></PopupTimeline>
        <ButtonWithIcon color="black" icon={<Play />} onClick={() => this.setState({ popupTenant: true })}>
          Pop-up composée Tenant
        </ButtonWithIcon>
        <PopupTimeline
          color="green"
          timelinePopupData={data.popup.tenant}
          open={this.state.popupTenant}
          onClose={() => this.setState({ popupTenant: false })}
        ></PopupTimeline>

        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupMaintainActivity: true })}>
          Pop-up composée MaintainActivity
        </ButtonWithIcon>
        <PopupTimeline
          color="green"
          timelinePopupData={data.popup.maintainActivity}
          open={this.state.popupMaintainActivity}
          onClose={() => this.setState({ popupMaintainActivity: false })}
        ></PopupTimeline>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupSafety: true })}>
          Pop-up composée Safety
        </ButtonWithIcon>
        <PopupSafety
          data={data}
          baseUrl={baseUrl}
          open={this.state.popupSafety}
          onClose={() => this.setState({ popupSafety: false })}
        ></PopupSafety>
        <ButtonWithIcon color="black" icon={<Play />} onClick={() => this.setState({ popupJeremyEstrader: true })}>
          Pop-up composée JeremyEstrader
        </ButtonWithIcon>
        <PopupJeremyEstrader
          data={data}
          baseUrl={baseUrl}
          open={this.state.popupJeremyEstrader}
          onClose={() => this.setState({ popupJeremyEstrader: false })}
        ></PopupJeremyEstrader>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupDialogue: true })}>
          Pop-up composée Dialogue
        </ButtonWithIcon>
        <PopupDialogue
          data={data}
          baseUrl={baseUrl}
          open={this.state.popupDialogue}
          onClose={() => this.setState({ popupDialogue: false })}
        ></PopupDialogue>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupReform: true })}>
          Pop-up composée Reform
        </ButtonWithIcon>
        <PopupTimeline
          timelinePopupData={data.popup.reform}
          open={this.state.popupReform}
          onClose={() => this.setState({ popupReform: false })}
        ></PopupTimeline>
        <ButtonWithIcon color="black" icon={<Play />} onClick={() => this.setState({ popupComfort: true })}>
          Pop-up composée Comfort
        </ButtonWithIcon>
        <PopupTimeline
          color="red"
          timelinePopupData={data.popup.comfort}
          open={this.state.popupComfort}
          onClose={() => this.setState({ popupComfort: false })}
        ></PopupTimeline>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupContinuity: true })}>
          Pop-up composée Continuity
        </ButtonWithIcon>
        <PopupTimeline
          color="green"
          timelinePopupData={data.popup.continuity}
          open={this.state.popupContinuity}
          onClose={() => this.setState({ popupContinuity: false })}
        ></PopupTimeline>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupIsabelleRueff: true })}>
          Pop-up composée Isabelle Rueff
        </ButtonWithIcon>
        <PopupIsabelleRueff
          data={data}
          baseUrl={baseUrl}
          open={this.state.popupIsabelleRueff}
          onClose={() => this.setState({ popupIsabelleRueff: false })}
        ></PopupIsabelleRueff>
        <ButtonWithIcon color="black" icon={<Play />} onClick={() => this.setState({ popupDiversity: true })}>
          Pop-up composée Diversity
        </ButtonWithIcon>
        <PopupTimeline
          color="yellow"
          timelinePopupData={data.popup.diversity}
          open={this.state.popupDiversity}
          onClose={() => this.setState({ popupDiversity: false })}
        ></PopupTimeline>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupDiagnostic: true })}>
          Pop-up composée Diagnostic
        </ButtonWithIcon>
        <PopupDiagnostic
          data={data}
          baseUrl={baseUrl}
          open={this.state.popupDiagnostic}
          onClose={() => this.setState({ popupDiagnostic: false })}
        ></PopupDiagnostic>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupTFPB: true })}>
          Pop-up composée TFPB
        </ButtonWithIcon>
        <PopupTFPB
          data={data}
          baseUrl={baseUrl}
          open={this.state.popupTFPB}
          onClose={() => this.setState({ popupTFPB: false })}
        ></PopupTFPB>
        <ButtonWithIcon color="black" icon={<Play />} onClick={() => this.setState({ popupRoadmap: true })}>
          Pop-up composée Roadmap
        </ButtonWithIcon>
        <PopupRoadmap
          data={data}
          baseUrl={baseUrl}
          open={this.state.popupRoadmap}
          onClose={() => this.setState({ popupRoadmap: false })}
        ></PopupRoadmap>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupRevival: true })}>
          Pop-up composée Revival
        </ButtonWithIcon>
        <PopupRevival
          data={data}
          baseUrl={baseUrl}
          open={this.state.popupRevival}
          onClose={() => this.setState({ popupRevival: false })}
        ></PopupRevival>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupStrategy: true })}>
          Pop-up composée Strategy
        </ButtonWithIcon>
        <PopupStrategy
          data={data}
          baseUrl={baseUrl}
          open={this.state.popupStrategy}
          onClose={() => this.setState({ popupStrategy: false })}
        ></PopupStrategy>
        <ButtonWithIcon color="black" icon={<Play />} onClick={() => this.setState({ popupQualiHlm: true })}>
          Pop-up composée QualiHlm
        </ButtonWithIcon>
        <PopupQualiHlm
          data={data}
          baseUrl={baseUrl}
          open={this.state.popupQualiHlm}
          onClose={() => this.setState({ popupQualiHlm: false })}
        ></PopupQualiHlm>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupEvents: true })}>
          Pop-up composée Events
        </ButtonWithIcon>
        <PopupEvents
          data={data}
          open={this.state.popupEvents}
          onClose={() => this.setState({ popupEvents: false })}
        ></PopupEvents>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupTexts: true })}>
          Pop-up composée Texts
        </ButtonWithIcon>
        <PopupTimeline
          color="green"
          timelinePopupData={data.popup.texts}
          open={this.state.popupTexts}
          onClose={() => this.setState({ popupTexts: false })}
        ></PopupTimeline>
        <ButtonWithIcon color="black" icon={<Play />} onClick={() => this.setState({ popupRime: true })}>
          Pop-up composée Rime
        </ButtonWithIcon>
        <PopupTimeline
          color="blue"
          timelinePopupData={data.popup.rime}
          open={this.state.popupRime}
          onClose={() => this.setState({ popupRime: false })}
        ></PopupTimeline>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupPropositions: true })}>
          Pop-up composée Propositions
        </ButtonWithIcon>
        <PopupPropositions
          data={data}
          open={this.state.popupPropositions}
          onClose={() => this.setState({ popupPropositions: false })}
        ></PopupPropositions>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupsocialimoact: true })}>
          Pop-up composée SocialImpact
        </ButtonWithIcon>
        <PopupSocialImpact
          data={data}
          open={this.state.popupsocialimoact}
          baseUrl={baseUrl}
          onClose={() => this.setState({ popupsocialimoact: false })}
        ></PopupSocialImpact>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupsylvieruin: true })}>
          Pop-up composée Sylvie Ruin
        </ButtonWithIcon>
        <PopupSylvieRuin
          data={data}
          open={this.state.popupsylvieruin}
          baseUrl={baseUrl}
          onClose={() => this.setState({ popupsylvieruin: false })}
        ></PopupSylvieRuin>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popuplowcarbon: true })}>
          Pop-up composée LowCarbon
        </ButtonWithIcon>
        <PopupLowCarbon
          data={data}
          open={this.state.popuplowcarbon}
          baseUrl={baseUrl}
          onClose={() => this.setState({ popuplowcarbon: false })}
        ></PopupLowCarbon>
        <ButtonWithIcon color="black" icon={<Play />} onClick={() => this.setState({ popupeaseaccess: true })}>
          Pop-up composée EaseAccess
        </ButtonWithIcon>
        <PopupEaseAccess
          data={data}
          open={this.state.popupeaseaccess}
          baseUrl={baseUrl}
          onClose={() => this.setState({ popupeaseaccess: false })}
        ></PopupEaseAccess>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupemmanuellecosse: true })}>
          Pop-up composée Emmanuelle Cosse
        </ButtonWithIcon>
        <PopupEmmanuelleCosse
          data={data}
          open={this.state.popupemmanuellecosse}
          baseUrl={baseUrl}
          onClose={() => this.setState({ popupemmanuellecosse: false })}
        ></PopupEmmanuelleCosse>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupmariannelouis: true })}>
          Pop-up composée Marianne Louis
        </ButtonWithIcon>
        <PopupMarianneLouis
          data={data}
          open={this.state.popupmariannelouis}
          baseUrl={baseUrl}
          onClose={() => this.setState({ popupmariannelouis: false })}
        ></PopupMarianneLouis>
        <ButtonWithIcon color="black" icon={<Play />} onClick={() => this.setState({ popupfederation: true })}>
          Pop-up composée Fédérations
        </ButtonWithIcon>
        <PopupFederationOffices
          data={data}
          open={this.state.popupfederation}
          baseUrl={baseUrl}
          onClose={() => this.setState({ popupfederation: false })}
        ></PopupFederationOffices>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupproject: true })}>
          Pop-up composée Project
        </ButtonWithIcon>
        <PopupProject
          data={data}
          open={this.state.popupproject}
          baseUrl={baseUrl}
          onClose={() => this.setState({ popupproject: false })}
        ></PopupProject>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupschool: true })}>
          Pop-up composée School
        </ButtonWithIcon>
        <PopupSchool
          data={data}
          open={this.state.popupschool}
          baseUrl={baseUrl}
          onClose={() => this.setState({ popupschool: false })}
        ></PopupSchool>
        <ButtonWithIcon color="black" icon={<Play />} onClick={() => this.setState({ popupTimeline4: true })}>
          Pop-up composée Timeline4
        </ButtonWithIcon>
        <PopupTimeline
          timelinePopupData={data.popup.timeline4}
          open={this.state.popupTimeline4}
          onClose={() => this.setState({ popupTimeline4: false })}
        ></PopupTimeline>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupTimeline2: true })}>
          Pop-up composée Timeline2
        </ButtonWithIcon>
        <PopupTimeline
          timelinePopupData={data.popup.timeline2}
          open={this.state.popupTimeline2}
          onClose={() => this.setState({ popupTimeline2: false })}
        ></PopupTimeline>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupTimeline3: true })}>
          Pop-up composée Timeline3
        </ButtonWithIcon>
        <PopupTimeline
          timelinePopupData={data.popup.timeline3}
          open={this.state.popupTimeline3}
          onClose={() => this.setState({ popupTimeline3: false })}
        ></PopupTimeline>
        <ButtonWithIcon color="black" icon={<Play />} onClick={() => this.setState({ popupAlliance1: true })}>
          Pop-up composée Alliance
        </ButtonWithIcon>
        <PopupAlliance
          data={data}
          open={this.state.popupAlliance1}
          baseUrl={baseUrl}
          onClose={() => this.setState({ popupAlliance1: false })}
        ></PopupAlliance>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupBIM1: true })}>
          Pop-up composée BIM
        </ButtonWithIcon>
        <PopupBIM
          data={data}
          open={this.state.popupBIM1}
          baseUrl={baseUrl}
          onClose={() => this.setState({ popupBIM1: false })}
        ></PopupBIM>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupTimeline1: true })}>
          Pop-up composée Timeline1
        </ButtonWithIcon>
        <PopupTimeline
          timelinePopupData={data.popup.timeline1}
          open={this.state.popupTimeline1}
          onClose={() => this.setState({ popupTimeline1: false })}
        ></PopupTimeline>
        <ButtonWithIcon color="black" icon={<Play />} onClick={() => this.setState({ popupOrganismEscort1: true })}>
          Pop-up composée OrganismEscort
        </ButtonWithIcon>
        <PopupOrganismEscort
          data={data}
          open={this.state.popupOrganismEscort1}
          baseUrl={baseUrl}
          onClose={() => this.setState({ popupOrganismEscort1: false })}
        ></PopupOrganismEscort>

        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupAnnexeIncome1: true })}>
          Pop-up composée AnnexeIncome
        </ButtonWithIcon>
        <PopupAnnexeIncome
          data={data}
          open={this.state.popupAnnexeIncome1}
          baseUrl={baseUrl}
          onClose={() => this.setState({ popupAnnexeIncome1: false })}
        ></PopupAnnexeIncome>
        <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupUE1: true })}>
          Pop-up composée UE
        </ButtonWithIcon>
        <PopupUE
          data={data}
          open={this.state.popupUE1}
          baseUrl={baseUrl}
          onClose={() => this.setState({ popupUE1: false })}
        ></PopupUE>
        <ButtonWithIcon color="black" icon={<Play />} onClick={() => this.setState({ popupTaxationEvolution1: true })}>
          Pop-up composée TaxationEvolution
        </ButtonWithIcon>
        <PopupTaxationEvolution
          data={data}
          open={this.state.popupTaxationEvolution1}
          baseUrl={baseUrl}
          onClose={() => this.setState({ popupTaxationEvolution1: false })}
        ></PopupTaxationEvolution>
        <Typography variant="h3" gutterBottom>
          Les typos
        </Typography>
        <Typography variant="h1" gutterBottom>
          h1. Heading
        </Typography>
        <Typography variant="h2" gutterBottom>
          h2. Heading
        </Typography>
        <Typography variant="h3" gutterBottom>
          h3. Heading
        </Typography>
        <Typography variant="h4" gutterBottom>
          h4. Heading
        </Typography>
        <Typography variant="h5" gutterBottom>
          h5. Heading
        </Typography>
        <Typography variant="h6" className="blue" gutterBottom>
          h6. Heading
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          subtitle1. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos blanditiis tenetur
        </Typography>
        <Typography variant="subtitle2" gutterBottom>
          subtitle2. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos blanditiis tenetur
        </Typography>
        <Typography variant="body1" gutterBottom>
          body1. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos blanditiis tenetur unde suscipit, quam
          beatae rerum inventore consectetur, neque doloribus, cupiditate numquam dignissimos laborum fugiat deleniti?
          Eum quasi quidem quibusdam.
        </Typography>
        <Typography variant="body2" gutterBottom>
          body2. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos blanditiis tenetur unde suscipit, quam
          beatae rerum inventore consectetur, neque doloribus, cupiditate numquam dignissimos laborum fugiat deleniti?
          Eum quasi quidem quibusdam.
        </Typography>
        <Typography variant="button" display="block" gutterBottom>
          button text
        </Typography>
        <Typography variant="caption" display="block" gutterBottom>
          caption text
        </Typography>
        <Typography variant="overline" display="block" gutterBottom>
          overline text
        </Typography>
        <br />
        <div>
          <Typography variant="h3" gutterBottom>
            Les boutons
          </Typography>
          <ButtonWithIcon icon={<Add />} iconPosition="above">
            Découvrir cette interview <br />
            qui recèle plein de petits secrets
            <br />
            dont vous n&apos;avez peut-être jamais
            <br />
            entendu parler
          </ButtonWithIcon>
          <ButtonWithIcon icon={<Download />}>
            <div>
              Découvrir cette interview <br />
              qui recèle plein de petits secrets
              <br />
              dont vous n&apos;avez peut-être jamais
              <br />
              entendu parler
            </div>
          </ButtonWithIcon>
          <ButtonWithIcon color="blue" icon={<Podcast />}>
            Découvrir ce podcast
          </ButtonWithIcon>
          <ButtonWithIcon icon={<Play />} iconPosition="top">
            Découvrir cet interview <br />
            qui recèle plein de petits secrets
            <br />
            dont vous n&apos;avez peut-être jamais
            <br />
            entendu parler
          </ButtonWithIcon>
        </div>
        <br />
        <div>
          <Typography variant="h3" gutterBottom>
            Les Typo encadrées
          </Typography>
          <div>
            <TypoFramed variant="body1">
              {parse('Directrice générale de l&apos;Union sociale pour l&apos;habitat')}
            </TypoFramed>
          </div>
          <br />
          <div>
            <TypoFramed frame="white" variant="h4" space={false}>
              {parse('L&apos;action<br /> de l&apos;Union<br /><b>en chiffres </b>')}
            </TypoFramed>
          </div>
          <br />
          <div>
            <TypoFramed variant="h4">{parse('L&apos;action<br /> de l&apos;Union<br />en <b>chiffres</b>')}</TypoFramed>
          </div>
          <br />
          <div>
            <TypoFramed variant="body1">{parse('Valérie Fournier')}</TypoFramed>
          </div>
        </div>
        <br />
        <Typography variant="h3" gutterBottom>
          Les cards
        </Typography>
        <div>
          <Card
            data={data}
            title={parse(data.blocks.b5federations.card1.title)}
            color="green"
            imgSrc={`${baseUrl}/blocks/${parse(data.blocks.b5federations.card1.imgSrc)}`}
          >
            <div>
              <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupTimelineTest: true })}>
                Pop-up basique type Timeline
              </ButtonWithIcon>
            </div>
            <div>
              <ButtonWithIcon color="black" icon={<Play />} onClick={() => this.setState({ popupInterview1: true })}>
                Pop-up basique type Interview
              </ButtonWithIcon>
            </div>
          </Card>
        </div>
        <br />
        <div>
          <Card
            data={data}
            title={parse(data.blocks.b5federations.card2.title)}
            color="green"
            imgSrc={`${baseUrl}/blocks/${parse(data.blocks.b5federations.card2.imgSrc)}`}
          >
            <div>
              <ButtonWithIcon color="black" icon={<Add />} onClick={() => this.setState({ popupArticle1: true })}>
                Pop-up composée Article
              </ButtonWithIcon>
            </div>
            <div>
              <ButtonWithIcon
                color="black"
                icon={<Add />}
                onClick={() => this.setState({ PopupFederationOfficesn1: true })}
              >
                Pop-up composée Fédération
              </ButtonWithIcon>
            </div>
            <div>
              <ButtonWithIcon color="black" icon={<Play />} onClick={() => this.setState({ popupArticle1: true })}>
                Pop-up composée Article
              </ButtonWithIcon>
            </div>
          </Card>
        </div>
        <br />
        <div>
          <Card
            data={data}
            title={parse(data.blocks.b5federations.card3.title)}
            color="green"
            imgSrc={`${baseUrl}/blocks/${parse(data.blocks.b5federations.card3.imgSrc)}`}
            onClick={() => this.setState({ popupInterview2: true })}
          >
            <div>
              <Typography>{parse('Raconté par')}</Typography>
            </div>
            <div>
              <TypoFramed size="small">{parse('Valérie Fournier')}</TypoFramed>
            </div>
          </Card>
        </div>
        <br />
        <br />
        <Typography variant="h3">Les sliders</Typography>
        <br />
        <br />
        <Slider sliderData={data.blocks.b7slider}></Slider>
        <br />
        <br />
        <PopupFederationOffices
          data={data}
          open={this.state.PopupFederationOfficesn1}
          baseUrl={baseUrl}
          onClose={() => this.setState({ PopupFederationOfficesn1: false })}
        ></PopupFederationOffices>
        <PopupArticle
          data={data}
          open={this.state.popupArticle1}
          baseUrl={baseUrl}
          onClose={() => this.setState({ popupArticle1: false })}
        ></PopupArticle>
        <PopupTimeline
          timelinePopupData={data.popup.timeline1}
          open={this.state.popupTimelineTest}
          onClose={() => this.setState({ popupTimelineTest: false })}
        ></PopupTimeline>
        <PopupInterview
          data={data}
          baseUrl={baseUrl}
          interview={data.popup.federationOffices}
          open={this.state.popupInterview1}
          onClose={() => this.setState({ popupInterview1: false })}
        ></PopupInterview>
        <PopupInterview
          data={data}
          baseUrl={baseUrl}
          interview={data.popup.federationCoop}
          open={this.state.popupInterview2}
          onClose={() => this.setState({ popupInterview2: false })}
        ></PopupInterview>
      </div>
    );
  }
}

SystemDesignDemo.propTypes = {
  data: PropTypes.object,
  baseUrl: PropTypes.string,
};

export default SystemDesignDemo;
